
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.675 2.415a.75.75 0 00-1.342 0l-4.625 9.25a.75.75 0 000 .67l4.625 9.25a.75.75 0 001.342 0l4.624-9.25a.75.75 0 000-.67l-4.624-9.25zm-.671 17.157L8.218 12h7.572l-3.786 7.572zm.83-8.47c.033.032.08.048.142.048h.38c.04 0 .075-.014.104-.043a.141.141 0 00.044-.104V7.486a.142.142 0 00-.044-.104.141.141 0 00-.103-.043h-.441a.141.141 0 00-.104.043.142.142 0 00-.043.104v2.243l-1.525-2.265a1.033 1.033 0 00-.07-.076c-.033-.033-.08-.05-.142-.05h-.381a.141.141 0 00-.104.044.141.141 0 00-.043.104v3.517c0 .04.014.075.043.104.03.029.064.043.104.043h.44c.04 0 .075-.014.104-.043a.141.141 0 00.044-.104V8.76l1.524 2.265c.015.018.038.043.071.076z"}})])
          )
        }
      }
    